// src/pages/VerifiedPage.jsx
import React, { useEffect, useState } from 'react';
import { useLocalizedNavigate } from '../hooks/useLocalizedNavigate';
import { CheckCircle, ArrowRight } from 'lucide-react';

const VerifiedPage = () => {
  const navigate = useLocalizedNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const countdownTimer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownTimer);
          handleRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownTimer);
  }, []);

  const handleRedirect = () => {
    navigate('/dashboard');
  };

  const handleContinueClick = () => {
    handleRedirect();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-2xl shadow-xl text-center max-w-md w-full">
        <div className="mb-6">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          <div className="w-20 h-1 bg-green-500 mx-auto rounded-full"></div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Email Verified Successfully! 🎉
        </h1>

        <p className="text-gray-600 mb-6">
          Welcome to Logami! Your account has been verified and you can now start your German language learning journey.
        </p>

        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
          <p className="text-green-800 text-sm font-medium">
            ✅ Email verification complete<br/>
            ✅ Account activated<br/>
            ✅ Ready to learn German!
          </p>
        </div>

        <div className="space-y-4">
          <button
            onClick={handleContinueClick}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
          >
            <span>Continue to Logami</span>
            <ArrowRight className="w-4 h-4" />
          </button>

          <p className="text-sm text-gray-500">
            {countdown > 0 ? (
              <>Automatically redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...</>
            ) : (
              <>Redirecting now...</>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifiedPage;